var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:( _obj = {}, _obj[("button_" + _vm.type)] = true, _obj.button_disabled = _vm.loading, _obj )},[(_vm.loading)?_c('loader',{attrs:{"size":"15px","border":"3px","absolute":""}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }